<template>
    <div class>
      <el-card>
        <div slot="header" class="clearfix">
          <span style="font-weight:600;color:#000">机构信息</span>
          <el-button type="success" plain @click="cancel" style="float: right; padding: 3px 0">返回</el-button>
        </div>
        <div class>
          <SForm
              ref="formref"
              :fields="formfields"
              :dataForm="rowdata"
              labelWidth="150px"
              :isShowBtn="false"
              :inline="false"
          >
          </SForm>
        </div>
      </el-card>
      <el-card>
        <div slot="header" class="clearfix">
          <span style="font-weight:600;color:#000">联系信息</span>
        </div>
        <div class>
            <SForm
                ref="lastformref"
                :fields="lastformfields"
                :dataForm="rowdata"
                labelWidth="150px"
                :isShowBtn="false"
                :inline="false"
            >
            </SForm>
        </div>
      </el-card>
      <!-- <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;" >
        <el-button @click="cancel" class="resetbtn">返回</el-button>
      </div> -->
    </div>
</template>

  <script>
  import { HOST, EV_HOST } from "@/utils/host";
  export default {
    name: "chongdianqiangxiangqing",
    components: {},
    data() {
      return {
        // 电桩信息
        rowdata: {},
        formfields: [
            {
                label: "机构名称",
                type: "div",
                prop: "name",
            },
            {
                label: "机构注册地址",
                type: "div",
                prop: "address",
            },
            {
                label: "统一社会信用代码",
                type: "div",
                prop: "code",
            },
        ],
        formbefore: record => {
            console.log(record);
            return record;
        },
        lastformfields: [
            {
                label: "联系人",
                type: "div",
                prop: "contactUser",
            },
            {
                label: "联系方式",
                type: "div",
                prop: "contactNum",
            },
            {
                label: "联系地址",
                type: "div",
                prop: "contactAddress",
            },
            {
                label: "联系邮箱",
                type: "div",
                prop: "email",
            },
            {
                label: "备注说明",
                type: "div",
                prop: "remark",
            }
        ],
        lastformbefore: record => {
            console.log(record);
            return record;
        },
        id: "",
      };
    },
    computed: {
    },
    methods: {
        cancel() {
            this.$router.go(-1);
        },

        getDataDetail() {
            let data = {
                id: this.id
            }
            let that = this;
            this.$store.dispatch("form/handle", {
                url: "/org/getDataDetail",
                method: "get",
                data: data,
                callback: resp => {
                    console.log("resp2",resp)
                    this.rowdata.creatTime = resp.signStartTime + "至" + resp.signEndTime
                    this.rowdata = resp;
                    if (resp.orgType == 0) {
                        this.formfields.splice(4,1);
                    } else if (resp.orgType == 1) {
                        this.formfields.splice(2,1);
                    }
                    this.rowdata.attr = resp.attr === 0 ? "自营" : resp.attr === 1 ? "加盟" : "第三方平台"
                    this.rowdata.orgType = (resp.orgType === 0 ? "电站运营商" : (resp.orgType === 1 ? "车辆机构" : (resp.orgType === 2 ? "流量方" : "车辆机构+运营商")))
                    this.rowdata.createTime = resp.signStartTime + " 至 " + resp.signEndTime
                }
            });
        },
    },
    mounted() {
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {
      this.id = this.$route.query.data
      this.getDataDetail()
    }, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
  };
  </script>

  <style lang="less" src="" scoped>
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00
}
.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color:#00cc00;
}
  </style>



// WEBPACK FOOTER //
// src/views/BMS/organManagement/operatorDetail.vue